import React from 'react';
import { Box, Typography } from '@mui/material';

interface ParallaxHeaderProps {
    title: string;
    description: string;
    imageUrl: string;
    height?: string | number;
}

const ParallaxHeader: React.FC<ParallaxHeaderProps> = ({ title, description, imageUrl, height = 150 }) => {
    return (
        <Box
            sx={{
                position: 'relative',
                width: '100%',
                height,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                overflow: 'hidden',
                mb: 6,
            }}
        >
            <Box
                sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundImage: `url(${imageUrl})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center center', // show center of image
                    backgroundAttachment: 'fixed',
                    filter: 'brightness(0.6)',
                    zIndex: 1,
                }}
            />
            <Box
                sx={{
                    position: 'relative',
                    zIndex: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    width: '100%',
                }}
            >
                <Typography
                    variant="h1"
                    sx={{
                        color: 'white',
                        fontWeight: 700,
                        fontSize: { xs: '3rem', md: '4rem' },
                        textShadow: '0 4px 24px rgba(0,0,0,0.5)',
                        textAlign: 'center',
                    }}
                >
                    {title}
                </Typography>
                {description && (
                    <Typography
                        variant="subtitle1"
                        sx={{
                            color: 'white',
                            fontWeight: 400,
                            fontSize: { xs: '1.1rem', md: '1.5rem' },
                            textShadow: '0 2px 12px rgba(0,0,0,0.4)',
                            textAlign: 'center',
                            mt: 1,
                            mb: 0,
                            maxWidth: { xs: '90%', md: '70%' },
                        }}
                    >
                        {description}
                    </Typography>
                )}
            </Box>
        </Box>
    );
};

export default ParallaxHeader;
